<ng-template [ngIf]="selectedPipeline()" [ngIfElse]="notFound">
  <mat-accordion multi>
    <mat-expansion-panel
      *ngFor="let survey of surveyMenuDataSignal(); trackBy: trackByIdentify"
      [expanded]="survey.accordionIsExanded"
      (afterExpand)="setPanelState(survey.pipelineSurveyId, true)"
      (afterCollapse)="setPanelState(survey.pipelineSurveyId, false)"
    >
      <mat-expansion-panel-header>
        <div class="accordion-header">
          <mat-panel-title>{{ survey.title }}</mat-panel-title>
          <p class="accordion-description">{{ survey.surveyYear }}-{{ survey.surveyIdent }}</p>
        </div>
      </mat-expansion-panel-header>
      <div class="accordion-content" *ngIf="survey.totalEvents > 0">
        <mat-checkbox
          [disabled]="surveyMenuLayerIsLoadingIndicator()"
          [checked]="survey.eventIsChecked"
          (change)="selectionChanged($event.checked, survey, LayersTypes.SURVEY_EVENT_DATA_LAYER)"
        >
          Event Data
        </mat-checkbox>
        <div class="square" [style.background-color]="survey.eventsColor"></div>
        <mat-spinner *ngIf="surveyMenuLayerIsLoadingIndicator()" diameter="25" class="loading-spinner" />
        <button
          mat-icon-button
          (click)="exportGeoJson(survey, LayersTypes.SURVEY_EVENT_DATA_LAYER)"
          matTooltip="Download GeoJSON"
          [disabled]="!survey.eventIsChecked || surveyMenuLayerIsLoadingIndicator()"
        >
          <mat-icon>{{ fileDownloadIcon }}</mat-icon>
        </button>
      </div>
      <div class="accordion-content" *ngIf="survey.totalBathy > 0">
        <mat-checkbox
          [disabled]="surveyMenuLayerIsLoadingIndicator()"
          [checked]="survey.bathyIsChecked"
          (change)="selectionChanged($event.checked, survey, LayersTypes.SURVEY_BATHY_DATA_LAYER)"
        >
          Bathymetric Data
        </mat-checkbox>
        <div class="square" [style.background-color]="survey.bathyColor"></div>
        <mat-spinner *ngIf="surveyMenuLayerIsLoadingIndicator()" diameter="25" class="loading-spinner" />
        <button
          mat-icon-button
          (click)="exportGeoJson(survey, LayersTypes.SURVEY_BATHY_DATA_LAYER)"
          matTooltip="Download GeoJSON"
          [disabled]="!survey.bathyIsChecked || surveyMenuLayerIsLoadingIndicator()"
        >
          <mat-icon>{{ fileDownloadIcon }}</mat-icon>
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>

<ng-template #notFound>
  <p>Please select a pipeline.</p>
</ng-template>
